import { render } from "./CommissionForm.vue?vue&type=template&id=17f59412&scoped=true"
import script from "./CommissionForm.vue?vue&type=script&lang=js"
export * from "./CommissionForm.vue?vue&type=script&lang=js"

import "./CommissionForm.vue?vue&type=style&index=0&id=17f59412&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f59412"]])

export default __exports__